import i18n from 'app-i18n';
import { Option } from 'util/multi-select';
import { array, object, string } from 'yup';
import { ObjectShape, OptionalObjectSchema } from 'yup/lib/object';

export const languageOptions = (): Option[] => {
  return [
    {
      id: 'EN',
      label: i18n.t('forms.fields.displayInformationField.languageOptions.en'),
    },
    {
      id: 'FR',
      label: i18n.t('forms.fields.displayInformationField.languageOptions.fr'),
    },
    {
      id: 'ES',
      label: i18n.t('forms.fields.displayInformationField.languageOptions.es'),
    },
  ];
};

export const getInitialLanguageCode = browserLanguageCode =>
  languageOptions()?.find(option => option.id === browserLanguageCode)
    ? browserLanguageCode
    : 'EN';

export const getLanguageLabel = code =>
  languageOptions()?.find(option => option.id === code)?.label;

export const makeDisplayInformationSchema = (
  fields: OptionalObjectSchema<ObjectShape>,
  defaultValue: Array<any> = [
    {
      languageCode: getInitialLanguageCode(
        navigator.language.split('-')[0].toUpperCase(),
      ),
    },
  ],
) =>
  array<any[]>(
    object()
      .shape({
        languageCode: string().required().oneOf(['EN', 'FR', 'ES']),
      })
      .concat(fields),
  )
    .min(1)
    .default(defaultValue);

export const generateLanguageLabel = (selectedOptions): string => {
  if (
    selectedOptions.length === 1 &&
    selectedOptions[0].languageCode !== 'EN'
  ) {
    return ` (${selectedOptions[0].languageCode})`;
  } else if (selectedOptions.length > 1) {
    return ` (${selectedOptions.map(option => option.languageCode).join('/')})`;
  } else {
    return '';
  }
};
